import { useQuery } from "@apollo/client/react";

import { useAuth } from "./use-auth";
import { useTeam } from "./use-team";
import { useWatchUserWsEvent } from "./use-watch-user-ws-event";
import GET_ORGANIZATION_BY_UUID from "../graphql/queries/GetOrganization";

export const useOrganization = () => {
  const { currentTeam } = useTeam();
  const { userUuid } = useAuth();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const orgUuid = (currentTeam as any)?.orgUuid || null;

  const {
    data,
    refetch,
    loading: isLoadingOrganization,
  } = useQuery(GET_ORGANIZATION_BY_UUID, {
    variables: { uuid: orgUuid },
    skip: !orgUuid,
  });

  const organization = data?.organization || null;

  const isOrgAdmin = (() => {
    if (!organization?.admins) return false;
    return organization.admins.some(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (admin: any) => admin?.uuid === userUuid,
    );
  })();

  const handleRefetch = () => {
    if (!orgUuid) return;
    refetch();
  };

  useWatchUserWsEvent({
    onMessage: handleRefetch,
    eventName: "user_update",
  });

  const hasOrganization = !!organization;

  return {
    organization,
    orgUuid,
    isOrgAdmin,
    hasOrganization,
    refetchOrganization: refetch,
    isLoadingOrganization,
  };
};
